import { Card, Skeleton, Tag, Typography } from "antd";
import { useState } from "react";

import styles from "./DocCard.module.scss";

const { Title } = Typography;

interface Props {
  title: string;
  docCount: number;
  docType: string;
  icon: any;
  loading: boolean;
  onClick(onClick: any): any;
}

const DocCard: React.FC<Props> = ({ title, docCount, docType, icon, loading, onClick }) => {
  const [loadingCover, setLoadingCover] = useState(true);

  return (
    <Card onClick={onClick} //TODO putting onClick here so the whole card is clickable. Disable this click while fetching the unread count or move this onClick to actions
      className={`mt-2 ml-2 mr-2 ${styles['card-container']}`}
      hoverable
      loading={loading}
      style={{border: "1px solid #D9D9D9"}}
    >
      <Skeleton loading={loading} active paragraph={{ rows: 8 }}>
        <div style={{textAlign: "center"}}>
          <Title level={5}>{title}</Title>
        </div>
        <div className={styles['card-content']}>
          <Title level={2}>{docCount}</Title>
        </div>
        <div className={styles['card-content']}>
          <p>Unread {docType}</p>
        </div>
        <div className={styles['card-content']}>
          <Tag style={{borderRadius: '5px'}} color="#476CAE">View Docs</Tag>
        </div>
      </Skeleton>
    </Card>
  );
};

export default DocCard;
